<!-- src/components/MaintenanceSchedule.vue -->
<template>
  <div class="p-4 pl-5 border-radius-8 border-brown-300 border-radius">
    <div class="font-weight-bold s-24 text-head mb-4">Maintenance Schedule</div>

    <!-- Maintenance Notice -->
    <div
      class="d-flex justify-content-between align-items-center p-3 rounded mb-4 gradient-bg text-white flex-column flex-md-row text-center text-md-left"
    >
      <div class="d-flex align-items-center">
        <div
          class="rounded-circle d-flex justify-content-center align-items-center mr-3"
          style="width: 50px; height: 50px; background: #e5ff70"
        >
          <GearFineIcon class="w-15 h-15 text-dak" />
        </div>
        <div class="text-dak">
          <div class="font-weight-bold s-20">
            Next Asset Maintenance <span class="fw-500">Schedule</span>
          </div>
          <div class="fw-500 s-20">
            comes up on 25/08/2025
            <!-- comes up on {{ date(data.scheduledDate) || "" }} -->
          </div>
        </div>
      </div>
      <el-button :color="primarycolor" round size="large" class="mt-3 mt-md-0"
        >Mark as Completed</el-button
      >
    </div>

    <div class="row mt-5">
      <!-- Left Side -->
      <div class="col-md-6">
        <div class="col-md-12">
          <label class="font-weight-600">Last Maintained</label>
          <!-- <el-input
            type="text"
            size="medium"
            class="w-100"
            v-model="lastMaintained"
          /> -->
          <el-date-picker
            v-model="lastMaintained"
            type="date"
            format="MM/DD/YYYY"
            size="large"
            class="w-100"
          />
        </div>

        <div class="col-md-12 mt-4">
          <label class="font-weight-600"> Maintenance Frequency</label>
          <el-select-v2
            v-model="selectedFrequencyId"
            @change="setSelectedFrequency"
            :options="
              maintenanceFrequency.map((i) => ({ label: i.name, value: i.id }))
            "
            placeholder="Select"
            size="large"
            class="w-100"
          />
        </div>

        <div class="col-md-6">
          <el-button
            color="#111111"
            size="large"
            round
            class="w-100 text-white mt-3"
            >Update schedule</el-button
          >
        </div>
      </div>

      <!-- Right Side -->
      <!-- <div class="col-md-6 mt-4 mt-md-0">
        <div class="bg-light2 p-3 rounded h-100">
          <div class="d-flex justify-content-between mb-3">
            <div class="fw-500 text-dak s-14">Asset Updates</div>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="s-10 fw-400 mr-1">March 2025 - April 2025</span>
              <span
                ><el-icon><CaretBottom /></el-icon
              ></span>
            </div>
          </div>

          <div class="calendar-grid">
            <div
              v-for="(day, index) in calendarDays"
              :key="index"
              class="calendar-cell"
              :class="{
                'text-success border-success calender-circle':
                  maintenanceDays.includes(day),
                'text-danger border-danger calender-circle':
                  warrantyDays.includes(day),
              }"
            >
              {{ day }}
            </div>
          </div>

          <div
            class="mt-3 d-flex justify-content-start s-10 fw-400 align-items-center"
          >
            <span class="legend-box bg-success mr-2"></span> Maintenance
            <span class="legend-box bg-danger ml-4 mr-2"></span> Warranty
          </div>
        </div>
      </div> -->
    </div>

    <div class="text-right mt-4" @click="viewMaintenanceHistory">
      <div class="fw-500 s-20 text-black"><u>See Maintenance history</u></div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, computed } from "vue";
import GearFineIcon from "../../../components/icons/GearFineIcon.vue";
import router from "../../../router";
import monthDayYear from "../../../services/dates/dateformatter";

const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
});

const date = (offDate) => {
  return monthDayYear.monthDayYear(offDate);
};
const primarycolor = inject("primarycolor");

const calendarDays = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "01",
  "02",
  "03",
  "04",
];

const maintenanceDays = ["06", "03"]; // days with green circle
const warrantyDays = ["29"]; // days with red circle
const selectedFrequency = ref({});
const lastMaintained = ref(new Date().now);
const selectedFrequencyId = ref(null);

const maintenanceFrequency = computed(() => {
  if (!Array.isArray(props.data)) return [];

  // Use Map to get unique frequencies by value
  const freqMap = new Map();

  props.data.forEach((item) => {
    if (!freqMap.has(item.frequency)) {
      freqMap.set(item.frequency, {
        name: `${item.frequency} days`,
        id: item.id,
      });
    }
  });

  return Array.from(freqMap.values());
});
// const maintenanceFrequency = computed(() => {
//   return props.data?.map((item) => ({
//     name: `${item.frequency} days`,
//     id: item.id,
//   })) || [];
// });

const setSelectedFrequency = () => {
  selectedFrequency.value = maintenanceFrequency.value.find((i) => {
    return i.id == selectedFrequencyId.value;
  });
};
const viewMaintenanceHistory = () => {
  router.push("/tenant/asset/assetmaintenancehistory");
};
</script>

<style scoped>
.gradient-bg {
  background: linear-gradient(90deg, #88ffc3 0%, #07f86b 53%, #ffffff 100%);
}
.gradient-bg1 {
  background: linear-gradient(90deg, #ff6863 0%, #fe230f 53%, #ffffff 100%);
}
.gradient-bg2 {
  color: white;
  background: linear-gradient(90deg, #fff588 0%, #ffc965 53%, #ffffff 100%);
}
.bg-light2 {
  background-color: #edf4ff;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.5rem;
  font-size: 10px;
}

.calendar-cell {
  padding: 0.5rem;
  text-align: center;
  height: 30px;
  width: 30px;
}

.calender-circle {
  border: 1px solid #ccc;
  border-radius: 50%;
  padding: 0.5rem;
  height: 30px;
  width: 30px;
  object-fit: contain;
}

.legend-box {
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 3px;
}
</style>
